import Vue from 'vue';
export default class alarmCenter {
    constructor(parent,options){
        this.system = parent;
        this.db = parent.dbCom;  
        this.objName = options.name
    }
    async getAlarm(param){
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(this._additionalConfig({
                name : this.objName,
                head : "getAlarm",
                param : param
            }),async (err,result)=>{
                if(err){
                    console.log(err);
                    resolve([]);
                }else if(result){
                    if(result.length != undefined){
                        resolve(result)
                    }else{
                        resolve([result])
                    }
                    
                }else{
                    resolve([])
                }
            });
        }) 
    }
    /**
     * 
     * @param {*过滤类型} type 
     * @param {*过滤条件} ide 
     */
    async GetAlarmIds(type,ide){
        var data = {
            type : type
        }
        if(type == "name"){
            data.name = ide;
        }else if(type == "type"){
            data.alarmType = ide;
        }else{
            data.type = "id";
        }
        var result = await this.getAlarm(data);
        return await new Promise((resolve, reject)=>{
            var showResult = [];
            if(!result.err){
                for(var p in result){
                    showResult.push({
                        model : result[p].modelName,
                        rule : result[p].ruleName,
                        time : result[p].startTime,
                        id : result[p]._id
                    });
                }
            }
            this.system.$store.state.system.alarmIdsShow.$.show("alarm",showResult,resolve);
        })
    }
    /**
     * 
     * @param {*模型名称} modelName 
     */
    async GetModelInfo(modelName){
        return await new Promise((resolve, reject)=>{
            var names = modelName.split(".");
            this.db.sendMessage(this._additionalConfig({
                name : this.objName,
                head : "getModelInfo",
                param : {
                    modelName : names[0]
                }
            }),async (err,result)=>{
                if(err){
                    console.log(err);
                    resolve();
                }else if(result){
                    result = result.alarmRules;
                    if(result[0]){
                        if(names[1]){
                            if(names[2]){
                                if(result[0][names[1]]){
                                    resolve(result[0][names[1]][names[2]]);
                                }else{
                                    resolve();
                                }
                                return;
                            }else{
                                resolve(result[0][names[1]]);
                                
                            }
                        }else{
                            resolve();
                        }
                    }
                }else{
                    resolve()
                }
            });
        }) 
    }
    /**
     * 
     * @param {*过滤类型 model(模型)/rule(规则)/type(类型)/空字符(所有)} type 
     * @param {*过滤条件 与type对应 (模型名称)/(模型名称.规则名称)/(规则类型字符串)} ide 
     */
    async GetAlarmCount(type,ide){
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(this._additionalConfig({
                name : this.objName,
                head : "getAlarmCount",
                param : {
                    type : type,
                    ide : ide
                }
            }),async (err,result)=>{
                if(err){
                    resolve([]);
                }else if(result){
                    if(result == null && result == undefined && result == ""){
                        result = 0;
                    }
                    resolve(result)
                }else{
                    resolve(result)
                }
            });
        }) 
    }
    /**
     * 获取报警确认人
     * @param {*报警id} id 
     */
	async GetConfirmerUser(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0] && result[0].confirmInfo){
            return result[0].confirmInfo.user
        }else{
            return; 
        }
    }
    /**
     * 获取报警确认人  旧版不在修改 为了兼容
     * @param {*报警id} id 
     */
	async GetConfirmerUse(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0] && result[0].confirmInfo){
            return result[0].confirmInfo.user
        }else{
            return; 
        }
    }
    /**
     * 获取报警确认时间
     * @param {*报警id} id 
     */
	async GetConfirmerTime(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0] && result[0].confirmInfo){
            return result[0].confirmInfo.time
        }else{
            return; 
        }
    }
    /**
     * 获取报警确认原因
     * @param {*报警id} id 
     */
	async GetConfirmerReason(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0] && result[0].confirmInfo){
            return result[0].confirmInfo.reason
        }else{
            return; 
        }
    }
    /**
     * 获取报警值
     * @param {*报警id} id 
     */
	async GetAlarmValue(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0] && result[0].curData){
            return parseFloat(result[0].curData.alarmValue);
        }else{
            return; 
        }
    }
    /**
     * 获取结束时间
     * @param {*报警id} id 
     */
	async GetAlarmEnd(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0]){
            return result[0].endTime;
        }else{
            return; 
        }
    }
    /**
     * 获取开始时间
     * @param {*报警id} id 
     */	
	async GetAlarmStart(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0]){
            return result[0].startTime;
        }else{
            return; 
        }
    }
    /**
     * 是否确认
     * @param {*模型名称+规则名称(规则名称可以不存在)} id 
     */
	async IsConfirmer(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0]){
            return result[0].confirmFlag > 0 ? true : false;
        }else{
            return; 
        }
    }
    /**
     * 获取报警等级
     * @param {*报警id} id 
     */
	async GetAlarmLeve(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0]){
            return result[0].ruleLevel
        }else{
            return; 
        }
    }
	/**
     * 获取报警类型
     * @param {*报警id} id 
     */
	async GetAlarmType(id){
        var result = await this.getAlarm({
            type : "id",
            id : id
        })
        if(result[0]){
            return result[0].modelType
        }else{
            return; 
        }
    }
    
    /**
     * 显示所有模型
     */
	async ShowModel(){
        var result = await this.getAlarm({
            type : "id"
        });
        return await new Promise((resolve, reject)=>{
            var showResult = [];
            if(!result.err){
                for(var p in result[0]){
                    showResult.push({
                        model : result[0][p].modelName,
                        rule : result[0][p].ruleName,
                        time : result[0][p].startTime,
                        id : result[0][p]
                    });
                }
            }
            this.system.$store.state.system.alarmIdsShow.$.show("model",showResult,resolve);
        })
    }

    /**
     * 显示所有模型
     */
	async IsAlarm(name){
        var result = await this.getAlarm({
            type : "name",
            name : name
        })
        if(result[0]){
            return result.length > 0 ? true:false;
        }else{
            return false; 
        }
    }

    /**
     * 判断指定的模型或规则、等级是否报警
     */
	async IsAlarmEx(name,level){
        var result = await this.getAlarm({
            type : "name",
            name : name
        })
        if(result){
            for(var i=0;i<result.length;i++){
                if(result[i].ruleLevel == level){
                     return true;
                 }
            }
            return false;
        }else{
            return false; 
        }
    }

    /*
    功能：附加sql语句到报文。私有函数，外部不可对报文进行修改
    */
    _additionalConfig(config){
        return {
            head : "backstage",
            message : {
                head : "fvAlarmCenter",
                type : "api",
                message : config
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvAlarmCenter/index.js